"use client"

import React from "react"
import { useTheme } from "next-themes"
import { GraduationCap, Calculator, Scissors, Baby, HelpCircle } from "@/lib/icons"

export const LEVEL_META = {
  MATERNAL: { label: "Maternal", color: "#f59e0b", icon: Baby },
  KINDER: { label: "Kinder", color: "#f59e0b", icon: Baby },
  PREFIRST: { label: "Pre-First", color: "#f59e0b", icon: Baby },
  PRIMARIA: { label: "Primaria", color: "#22c55e", icon: Scissors },
  SECUNDARIA: { label: "Secundaria", color: "#0ea5e9", icon: Calculator },
  PREPARATORIA: { label: "Preparatoria", color: "#a855f7", icon: GraduationCap },
}

// Mapa de alias → clave canónica de LEVEL_META
const _LEVEL_ALIASES = {
  MATERNAL: "MATERNAL",
  MATERNA: "MATERNAL",
  KINDER: "KINDER",
  PREESCOLAR: "KINDER",
  KINDERGARDEN: "KINDER",
  PREFIRST: "PREFIRST",
  "PRE-FIRST": "PREFIRST",
  "PRE FIRST": "PREFIRST",
  PRIMARIA: "PRIMARIA",
  SECUNDARIA: "SECUNDARIA",
  PREPARATORIA: "PREPARATORIA",
  PREPA: "PREPARATORIA",
}

export function normalizeLevel(value) {
  if (!value) return null
  const v = String(value).trim().toUpperCase()
  if (LEVEL_META[v]) return v
  return _LEVEL_ALIASES[v] || null
}

export function LeadLevelAvatar({ nivel, size = 40, initials = "" }) {
  const key = normalizeLevel(nivel)
  const meta = LEVEL_META[key] || { label: "Sin definir", color: "#94a3b8", icon: HelpCircle }
  const Icon = meta.icon
  const { resolvedTheme } = useTheme()
  const isDark = resolvedTheme === "dark"

  // color base y variantes para borde / fondo
  const bgColor = meta.color || "#999999"
  const borderColor = isDark ? `${bgColor}8a` : `${bgColor}66`
  const background = isDark
    ? `linear-gradient(135deg, rgba(15,23,42,0.95), color-mix(in oklab, ${bgColor} 28%, #000))`
    : `${bgColor}1a`

  // si nos pasan iniciales, mostramos círculo con texto; si no, fallback al icono
  const content = initials && String(initials).trim()
    ? (String(initials).trim().slice(0, 2).toUpperCase())
    : null

  return (
    <span
      className="relative flex items-center justify-center rounded-full shadow-sm"
      style={{
        width: size,
        height: size,
        border: `1.5px solid ${borderColor}`,
        background,
        color: "#fff",
        fontWeight: 700,
        fontSize: Math.max(10, Math.floor(size * 0.4)),
        lineHeight: 1,
        textAlign: "center",
      }}
      aria-label={`Nivel: ${meta.label}`}
      title={meta.label}
    >
      {content ? (
        <span style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          borderRadius: "999px",
          background: `linear-gradient(135deg, ${bgColor}, ${bgColor}cc)`,
          color: "#fff",
        }}>
          {content}
        </span>
      ) : (
        // fallback al icono si no hay iniciales
        <Icon className="h-[60%] w-[60%]" style={{ color: isDark ? "#fff" : bgColor }} />
      )}
    </span>
  )
}

export default LeadLevelAvatar
